<template>
  <section
    v-if="visiable"
    class="tooltip">
    <el-tooltip
      effect="dark"
      placement="top">
      <div
        slot="content"
        class="content">
        <p>This user is using an email forwarding service. </p>
        <p>They might not remember this email.</p>
        <p>Service Provider: <b>{{provider}}</b></p>
      </div>
      <font-awesome-icon
        icon="user-ninja"
        class="icon"></font-awesome-icon>
    </el-tooltip>
  </section>
</template>

<script>
export default {
  name: '',
  props:{
    email:{
      type: String,
      default: ''
    }
  },
  data(){
    return {
      visiable: false,
      provider: '',
      providerList:{
        'Apple': ['@privaterelay.appleid.com'],
        'DuckDuckGo': ['@duck.com'],
        'Firefox Relay': ['@relay.firefox.com', '@mozmail.com', '.mozmail.com'],
        'SimpleLogin': ['@simplelogin.co', '@simplelogin.fr', '@8alias.com', '@dralias.com', '@aleeas.com', '@slmail.me', '@8shield.net']
      }
    }
  },
  watch:{
    email:{
      immediate: true,
      handler(val){
        this.visiable = false
        if(val){
          let res = this.getProvider(val)
          if(res){
            this.provider = res
            this.visiable = true
          }
        }
      }
    }
  },
  methods:{
    getProvider(email){
      let res = null
      Object.keys(this.providerList).forEach(key => {
        let arr = this.providerList[key]
        arr.some(item => {
          if(email.endsWith(item)){
            res = key
          }
        })
      })
      return res
    }
  }
}
</script>
<style lang='scss' scoped>
.tooltip{
  display: inline-block;
  margin-left: 7px;
  .icon{
    color: #0366D6;
  }
}
.content{
  p{
    text-align: center;
    line-height: 18px;
    &:last-child{
      margin-top: 5px;
    }
  }
}
</style>
